import React from 'react';
import { FeatureFlagApiResponse } from 'app_api/projects/feature_flags/types';
import { useFeatureFlagStore } from 'apps/feature-flags/src/store';
import { EditFeatureFlag } from '../edit';
import { FeatureFlagPageSummary } from '../summary';
import styles from './index.module.styl';
interface FeatureFlagPageMainProps {
  projectId: number;
  workspaceId: number;
  onUpdateFlag: (updatedFlag: FeatureFlagApiResponse) => void;
}
export function FeatureFlagPageMain(_ref: FeatureFlagPageMainProps) {
  let {
    projectId,
    workspaceId,
    onUpdateFlag
  }: FeatureFlagPageMainProps = _ref;
  const currentFeatureFlag = useFeatureFlagStore(store => store.currentFeatureFlag);
  const isEditModalOpen = useFeatureFlagStore(store => store.isEditModalOpen);
  const setEditModalOpen = useFeatureFlagStore(store => store.setEditModalOpen);
  if (!currentFeatureFlag) return null;
  const handleCloseEditModal = () => {
    setEditModalOpen(false);
  };
  return <main className={styles.main} data-sentry-component="FeatureFlagPageMain" data-sentry-source-file="index.tsx">
      <h1 className={styles.title}>{currentFeatureFlag.name}</h1>
      <FeatureFlagPageSummary onUpdateFlag={onUpdateFlag} projectId={projectId} workspaceId={workspaceId} data-sentry-element="FeatureFlagPageSummary" data-sentry-source-file="index.tsx" />

      <EditFeatureFlag isOpen={isEditModalOpen} onClose={handleCloseEditModal} flag={currentFeatureFlag} onUpdateFlag={onUpdateFlag} workspaceId={workspaceId} data-sentry-element="EditFeatureFlag" data-sentry-source-file="index.tsx" />
    </main>;
}